var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mt-5" }, [
      _c("div", [
        _c("h3"),
        _c("br"),
        _c("label", { attrs: { for: "" } }, [_vm._v("Tipo de Venta")]),
        _c("div", { staticClass: "vx-row mb-2" }, [
          _c(
            "div",
            { staticClass: "vx-col w-full" },
            [
              _c("v-select", {
                attrs: { options: _vm.tipo_de_venta },
                model: {
                  value: _vm.tipo,
                  callback: function($$v) {
                    _vm.tipo = $$v
                  },
                  expression: "tipo"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("br")
    ]),
    _c("div", { attrs: { align: "right" } }, [
      _c(
        "div",
        { staticStyle: { "text-align": "right" } },
        [
          _c(
            "vs-button",
            {
              attrs: { color: "primary", type: "filled" },
              on: {
                click: function($event) {
                  return _vm.modificarTipoVenta()
                }
              }
            },
            [_vm._v("Modificar")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }